import { render, staticRenderFns } from "./InvoiceTemplate.vue?vue&type=template&id=1a89eeae"
import script from "./InvoiceTemplate.vue?vue&type=script&lang=js"
export * from "./InvoiceTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports